import type { TenantBranding } from '@oms/contracts';
import { ZeritiMark } from '../../components/icons';

export function BrandHeader({ tenant, subtitle, platform = false }: { tenant: TenantBranding | null | undefined; subtitle?: string; platform?: boolean }) {
  const name = platform ? 'Zeriti Platform Console' : (tenant?.displayName ?? 'Zeriti');
  return (
    <div className="auth-brand">
      {tenant?.logoUrl && !platform ? (
        <img src={tenant.logoUrl} alt={`${tenant.displayName} logo`} />
      ) : platform || !tenant ? (
        <ZeritiMark size={44} />
      ) : (
        <span className="brand-mark" style={{ width: 44, height: 44, fontSize: 18 }} aria-hidden="true">
          {name.charAt(0).toUpperCase()}
        </span>
      )}
      <div>
        <div style={{ fontSize: 18, fontWeight: 600 }}>{name}</div>
        {subtitle && <div className="muted small">{subtitle}</div>}
      </div>
    </div>
  );
}
